import React from 'react'
import './Loader.css';

export const Loader = (props) => {
  return(
    <div className="loader">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
    </div>
  )
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js